<template>
  <div class="box m-1">
    <article class="media">
      <figure class="media-left">
        <p>
          <span>{{ reason.score_label }}</span>
        </p>
      </figure>
      <div class="media-content">
        <p v-if="reason.is_audio">
          <audio
            controls
            :src="'https://media.feedletter.co/' + reason.id + '.mp3'"
          ></audio>
        </p>
        <template v-else>
          <p v-if="!subscribed && reason.reason == 'unlockpro'">
            Limit Reached.
            <router-link
              :to="{ name: 'Upgrade' }"
              class="button is-small is-info is-inline"
              >Unlock Now</router-link
            >
          </p>

          <p v-else v-html="reason.reason">{{ reason.reason }}</p>
        </template>
        <p v-if="reason.name || reason.email" class="is-size-6 mt-2 has-text-right">
          By {{ reason.name }} <br v-if="reason.name"/> {{ reason.email }}
          
        </p>
        <p class="is-size-7 mt-1 has-text-right has-text-grey	">
          {{ creationDateHuman}}
        </p>
        <p v-if="reason.external_content_ref" class="is-size-7 mt-1 has-text-right has-text-grey-light">
          On Page: {{ reason.external_content_ref}}
        </p>
        <p class="is-size-7 mt-1 has-text-right has-text-grey-light">
          ID: {{ reason.id}}
        </p>
        <p class="is-size-7 mt-1 has-text-right">
          <router-link
            :to="{
              name: 'FeedbackView',
              params: { formId: reason.form_id },
            }"
            >{{ reason.form_name }}
          </router-link>
        </p>

      </div>
      <div v-if="!reason.is_audio" class="media-right">
        <div class="dropdown is-hoverable">
          <div class="dropdown-trigger">
            <b-icon
              icon="more-vertical"
              size="is-small"
              aria-haspopup="true"
              aria-controls="dropdown-menu4"
            ></b-icon>
          </div>
          <div class="dropdown-menu" id="dropdown-menu4" role="menu">
            <div class="dropdown-content">
              <a class="dropdown-item" @click.prevent="copyAsImageToClipboard">
                Copy as Image to Clipboard
              </a>
              <a class="dropdown-item" @click.prevent="confirmDelete">
                Delete Feedback
              </a>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import atomic from "atomicjs"
export default {
  name: "FeedbackReasonCard",
  props: {
    subscribed: {
      type: Boolean,
      required: true,
      default: "",
    },
    reason: {
      type: Object,
      required: true,
    },
  },
  computed: {

    creationDateHuman() {
      const date = new Date(this.reason.created_at);

      // Specify options to display the full month name
      const options = { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' };

      // Use Intl.DateTimeFormat with desired locale, e.g., 'en-US' for English
      return new Intl.DateTimeFormat('en-US', options).format(date);
    },
  },
  methods: {
    wrapText: function (ctx, text, maxWidth, lineHeight) {
      var x = 0;
      var y = 0;
      var words = text.split(" ");
      var line = "";

      var lines = [];
      for (var n = 0; n < words.length; n++) {
        var testLine = line + words[n] + " ";
        var metrics = ctx.measureText(testLine);
        var testWidth = metrics.width;
        if (testWidth > maxWidth && n > 0) {
          lines.push({ text: line, x: x, y: y });
          line = words[n] + " ";
          y += lineHeight;
        } else {
          line = testLine;
        }
      }

      lines.push({ text: line, x: x, y: y });

      return lines;
    },
    copyAsImageToClipboard: function () {
      var p = document.createElement("div");
      p.innerHTML = this.reason.reason
      const text = p.innerText
      p.remove()
      
      var name = this.reason.name
      if (name &&
        (name.includes("@")
          || name.includes("http")
        )
      ) {
        name = "anonymous"
      }

      const who = "By " + (name || "anonymous").split(" ")[0]

      var canvas = document.createElement("canvas");
      canvas.width = 1200;
      canvas.height = 630;
      var ctx = canvas.getContext("2d");
      ctx.fillStyle = "#f1f1f1";
      ctx.textBaseline = "top";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      var commentFont = "bold 36pt Nunito"
      ctx.font = commentFont
      ctx.fillStyle = "#4a4a4a";
      var cornerRadius = 20;
      var maxWidth = 800;
      var lineHeight = 60;
      var x = (canvas.width - maxWidth) / 2 + 25;
      var offsetY = 25

      var lines = this.wrapText(ctx, text, maxWidth, lineHeight);
      console.log("lines", lines.length)

      if (lines.length > 20) {
        lineHeight = 26;
        offsetY = 10
        commentFont = "bold 16pt Nunito"
        ctx.font = commentFont
        lines = this.wrapText(ctx, text, maxWidth, lineHeight);
      } else if (lines.length > 6) {
        lineHeight = 44;
        offsetY = 10
        commentFont = "bold 24pt Nunito"
        ctx.font = commentFont
        lines = this.wrapText(ctx, text, maxWidth, lineHeight);
      }
      
      var y = 250 - (offsetY * lines.length);
      var rectX = x - 25;
      var rectY = y - 25;
      var rectWidth = maxWidth + 50;
      var rectHeight = lines.length * lineHeight + 50;

      

      ctx.fillStyle = "#fff";
      ctx.strokeStyle = "#fff";
      ctx.lineJoin = "round";
      ctx.lineWidth = cornerRadius;
      // Change origin and dimensions to match true size (a stroke makes the shape a bit larger)
      ctx.strokeRect(
        rectX + cornerRadius / 2,
        rectY + cornerRadius / 2,
        rectWidth - cornerRadius,
        rectHeight - cornerRadius
      );
      ctx.fillRect(
        rectX + cornerRadius / 2,
        rectY + cornerRadius / 2,
        rectWidth - cornerRadius,
        rectHeight - cornerRadius
      );

      ctx.fillStyle = "#4a4a4a";
      ctx.font = "bold 36pt Nunito";
      ctx.fillText(this.reason.score_label, 100, y);
      
      ctx.font = commentFont
      for (var i = 0; i < lines.length; i++) {
        ctx.fillText(lines[i].text, lines[i].x + x, lines[i].y + y);
      }

      ctx.font = "normal 18pt Nunito";
      ctx.fillText(
        who,
        rectX + rectWidth - ctx.measureText(who).width - 25,
        y + rectHeight
      );

      var img = new Image(); // Create new img element
      img.crossOrigin = "anonymous"
      var self = this
      img.addEventListener(
        "load",
        function () {
          ctx.drawImage(img, 0, 0);
          canvas.toBlob(function (blob) {
            navigator.clipboard.write([
              new ClipboardItem({
                "image/png": blob,
              }),
            ]);
            self.$buefy.toast.open({
              duration: 3000,
              message: `Feedback copied to clipboard`,
              type: 'is-success'
            })
            canvas.remove()
          })
        },
        false
      );
      img.src = "/img/branding-overlay.png"
    },
    confirmDelete() {
      if(this.subscribed) {
        this.$buefy.dialog.confirm({
            message: 'Are you sure you want to delete this feedback? It is gone forever once you confirm.',
            type: 'is-danger',
            confirmText: 'Delete Feedback',
            onConfirm: async () => {
              console.log("confirmed delete dialog")
              var self = this;
              let loadingComponent = this.$buefy.loading.open({
                container: this.$el
              })

              this.$store.dispatch('getAPIToken')
                .then((response) => {
                  atomic( self.apiHost + "feedback/" + self.reason.id, {
                    method: "DELETE",
                    headers: {
                      Authorization: "Bearer " + response,
                      "Content-type": "application/json",
                    },
                  })
                    .then(function (response) {
                      loadingComponent.close()
                      self.$emit("feedback-deleted", self.reason.id);
                      self.$buefy.toast.open({
                        duration: 3000,
                        message: `Feedback successfully deleted.`,
                        type: 'is-success'
                      })
                      //console.log(response.data); // xhr.responseText
                      //console.log(response.xhr); // full response
                    })
                    .catch(function (error) {
                      loadingComponent.close()
                      console.log(error.status); // xhr.status
                      console.log(error.statusText); // xhr.statusText
                    });
                })
                .catch((error) => {
                  this.$parent.$emit("unauthed")
                });
            }
        })
      } else {
        
        this.$buefy.dialog.confirm({
            message: 'You can only delete this form on the Professional or Business plans. Want to learn more about it?',
            type: 'is-info',
            confirmText: "Show me",
            onConfirm: async () => {
              this.$router.push("/upgrade")
            }
        })
      }
       
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
